import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import NeonBackground from './NeonBackground';
import DarkBackground from './DarkBackground';
import RetroBackground from './RetroBackground';

const ThemeBackground = () => {
  const { profile } = useAuth();
  const theme = profile?.theme || 'dark'; // El tema por defecto es 'dark'

  // Aplicar la clase de tema al elemento body
  useEffect(() => {
    // Eliminar todas las clases de tema anteriores
    document.body.classList.remove('theme-dark', 'theme-neon', 'theme-retro');
    
    // Aplicar la clase del tema actual
    document.body.classList.add(`theme-${theme}`);
    
    // Actualizar todas las variables CSS según el tema seleccionado
    if (theme === 'dark') {
      // Variables de fondo y color principal
      document.documentElement.style.setProperty('--bg-color', 'rgb(18, 18, 18)');
      document.documentElement.style.setProperty('--card-bg', 'rgba(18, 18, 18, 0.7)');
      document.documentElement.style.setProperty('--accent-color', '#3B82F6');
      
      // Variables de texto
      document.documentElement.style.setProperty('--text-color', '#ffffff');
      document.documentElement.style.setProperty('--text-secondary', 'rgba(209, 213, 219, 1)');
      
      // Variables de bordes y botones
      document.documentElement.style.setProperty('--border-color', 'rgba(55, 65, 81, 0.3)');
      document.documentElement.style.setProperty('--button-bg', 'rgba(59, 130, 246, 0.2)');
      document.documentElement.style.setProperty('--button-hover', 'rgba(59, 130, 246, 0.3)');
      document.documentElement.style.setProperty('--button-text', 'rgba(96, 165, 250, 1)');
      
      // Variables de input
      document.documentElement.style.setProperty('--input-bg', 'rgba(31, 41, 55, 0.7)');
      document.documentElement.style.setProperty('--input-border', 'rgba(55, 65, 81, 0.5)');
      document.documentElement.style.setProperty('--input-focus', 'rgba(59, 130, 246, 0.4)');
      
      // Variables de scrollbar
      document.documentElement.style.setProperty('--scrollbar-track', 'rgba(15, 23, 42, 0.3)');
      document.documentElement.style.setProperty('--scrollbar-thumb', 'rgba(59, 130, 246, 0.5)');
    } else if (theme === 'neon') {
      // Variables de fondo y color principal
      document.documentElement.style.setProperty('--bg-color', 'rgb(5, 5, 5)');
      document.documentElement.style.setProperty('--card-bg', 'rgba(5, 5, 5, 0.6)');
      document.documentElement.style.setProperty('--accent-color', '#00FFFF');
      
      // Variables de texto
      document.documentElement.style.setProperty('--text-color', '#ffffff');
      document.documentElement.style.setProperty('--text-secondary', 'rgba(209, 213, 219, 1)');
      
      // Variables de bordes y botones
      document.documentElement.style.setProperty('--border-color', 'rgba(0, 255, 255, 0.3)');
      document.documentElement.style.setProperty('--button-bg', 'rgba(0, 255, 255, 0.2)');
      document.documentElement.style.setProperty('--button-hover', 'rgba(0, 255, 255, 0.3)');
      document.documentElement.style.setProperty('--button-text', 'rgba(0, 255, 255, 1)');
      
      // Variables de input
      document.documentElement.style.setProperty('--input-bg', 'rgba(5, 5, 5, 0.7)');
      document.documentElement.style.setProperty('--input-border', 'rgba(0, 255, 255, 0.5)');
      document.documentElement.style.setProperty('--input-focus', 'rgba(0, 255, 255, 0.4)');
      
      // Variables de scrollbar
      document.documentElement.style.setProperty('--scrollbar-track', 'rgba(5, 5, 5, 0.5)');
      document.documentElement.style.setProperty('--scrollbar-thumb', 'rgba(0, 255, 255, 0.5)');
    } else if (theme === 'retro') {
      // Variables de fondo y color principal
      document.documentElement.style.setProperty('--bg-color', 'rgb(24, 0, 71)');
      document.documentElement.style.setProperty('--card-bg', 'rgba(24, 0, 71, 0.7)');
      document.documentElement.style.setProperty('--accent-color', '#DAA520');
      
      // Variables de texto
      document.documentElement.style.setProperty('--text-color', '#ffffff');
      document.documentElement.style.setProperty('--text-secondary', 'rgba(254, 243, 199, 1)');
      
      // Variables de bordes y botones
      document.documentElement.style.setProperty('--border-color', 'rgba(218, 165, 32, 0.3)');
      document.documentElement.style.setProperty('--button-bg', 'rgba(218, 165, 32, 0.2)');
      document.documentElement.style.setProperty('--button-hover', 'rgba(218, 165, 32, 0.3)');
      document.documentElement.style.setProperty('--button-text', 'rgba(251, 191, 36, 1)');
      
      // Variables de input
      document.documentElement.style.setProperty('--input-bg', 'rgba(24, 0, 71, 0.7)');
      document.documentElement.style.setProperty('--input-border', 'rgba(218, 165, 32, 0.5)');
      document.documentElement.style.setProperty('--input-focus', 'rgba(218, 165, 32, 0.4)');
      
      // Variables de scrollbar
      document.documentElement.style.setProperty('--scrollbar-track', 'rgba(24, 0, 71, 0.5)');
      document.documentElement.style.setProperty('--scrollbar-thumb', 'rgba(218, 165, 32, 0.5)');
    }
    
    console.log(`Tema cambiado a: ${theme}`);
  }, [theme]);

  // Renderizar el fondo adecuado según el tema seleccionado
  if (theme === 'neon') {
    return <NeonBackground />;
  } else if (theme === 'dark') {
    return <DarkBackground />;
  } else if (theme === 'retro') {
    return <RetroBackground />;
  }

  // Valor por defecto: tema oscuro
  return <DarkBackground />;
};

export default ThemeBackground; 